module.exports = __webpack_public_path__ + "img/logo.d81b4cff.png";